import { render, staticRenderFns } from "./CompanyInvoiceDialog.vue?vue&type=template&id=37ed601c&"
import script from "./CompanyInvoiceDialog.vue?vue&type=script&lang=js&"
export * from "./CompanyInvoiceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports